import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CalendarViewComponent } from './components/calendar-view/calendar-view.component';
import { ErrorComponent } from './components/error/error.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ApiConfiguration } from './api/api-configuration';
import { environment } from '../environments/environment';

@NgModule({ declarations: [
        AppComponent,
        CalendarViewComponent,
        ErrorComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        AppRoutingModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: ApiConfiguration,
            useFactory: () => {
                const config = new ApiConfiguration();
                config.rootUrl = environment.apiUrl;
                return config;
            }
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
